import { BaseModel } from "../../sso/models/base.model";

export class KmlModel extends BaseModel {
    Id: number = 0;
    EmpresaId: number = 0;
    Nombre: string = '';
    Url: string = '';
    Observaciones: string = '';
}